import { useStickyNotification } from '@hotjar/navigation';
import { useCurrentUser } from '@hotjar/user';
import { useLocation } from 'react-use';
import { useEffect, useState } from 'react';
import { Trans } from '@hotjar/translations';
import { useOrderStatus } from '~/subscription-management/queries/useOrderStatus';
import { SUBSCRIPTIONS } from '~/subscription-management/constants/routes';

export const SUBSCRIPTION_ERROR = 'checkout-order-error';

export const useOrderErrorAlerts = (): void => {
  const { show, hide } = useStickyNotification();
  const { data: user } = useCurrentUser();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const { data: orderStatus } = useOrderStatus(user?.accounts?.[0]?.id);

  // order failures
  useEffect(() => {
    if (
      !dismissed &&
      location.pathname?.includes(SUBSCRIPTIONS) === false &&
      orderStatus?.status === 'FAILED'
    ) {
      show(SUBSCRIPTION_ERROR, {
        kind: 'danger',
        isDismissible: true,
        onDismiss: () => setDismissed(true),
        text: (
          <Trans
            i18nKey="checkout:alerts.order-failures.in-app-message"
            components={[<strong />]}
          />
        ),
      });
    } else {
      hide(SUBSCRIPTION_ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderStatus, show, hide, location.pathname]);
};
